import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { appLoadDataAsyncThunk, updateAcceptPublicProposalAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function Index({ networkID, provider, address }) {

    const { analytics } = useSelector(state => state.bank);
    const { acceptPublicProposal } = analytics;
    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(appLoadDataAsyncThunk({ networkID, provider, address }))
        return () => {

        }
    }, [])


    return (
        <div className='method-component'>
            <h2>Make DBN {acceptPublicProposal ? 'disable' : 'enable'} Public proposal</h2>
            <p>You can enable/disable public proposals</p>
            <Form noValidate>
                <div className='contact-form'>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title={acceptPublicProposal ? 'Lock Transfer' : 'Allow Tranfer'}
                                type="submit"
                                slice={'bank'}
                                action={"updateAcceptPublicProposalAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                                onClick={(e) =>{
                                    e.preventDefault();
                                    dispatch(updateAcceptPublicProposalAsyncThunk({ update: !acceptPublicProposal, networkID, provider }))
                                }
                            }
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
